import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import Navbar from '../components/site/Navbar';
import FooterCTA from '../components/site/FooterCTA';
import Footer from '../components/site/Footer';
import { work } from '../data/mock';

const Pill = ({ children }) => (
  <span
    className="inline-block px-4 py-1.5 rounded-md font-display uppercase tracking-wider text-sm md:text-base"
    style={{ background: '#2EF5FF', color: '#12367F' }}
  >
    {children}
  </span>
);

const WorkHero = () => (
  <section className="pt-28 md:pt-36 pb-12 md:pb-16" style={{ background: '#FFFFFF' }}>
    <div className="container-x px-6">
      <Pill>Our Work</Pill>
      <h1
        className="mt-8 font-display uppercase text-[#12367F] text-balance max-w-6xl"
        style={{ fontSize: 'clamp(2.5rem, 8vw, 8.5rem)', lineHeight: 0.9 }}
      >
        Campaigns
        <br />
        <span style={{ background: '#2EF5FF' }} className="px-2 rounded-md">killing it</span>{' '}
        on social
      </h1>
      <p className="mt-8 max-w-2xl text-[#12367F]/85 text-base md:text-lg leading-relaxed">
        Case studies from our latest creator-led campaigns &mdash; the strategy, the creators,
        and the results that moved the needle for the world&apos;s biggest brands.
      </p>
    </div>
  </section>
);

const Work = () => {
  return (
    <main className="bg-white text-[#12367F]">
      <Navbar />
      <WorkHero />

      <section className="pb-20 md:pb-28" style={{ background: '#FFFFFF' }}>
        <div className="container-x px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {work.map((w) => (
              <div key={w.id} className="work-card group block cursor-default">
                <div className="relative rounded-3xl overflow-hidden aspect-[4/5] bg-[#12367F]/10">
                  <img
                    src={w.image}
                    alt={w.title}
                    loading="lazy"
                    className="work-img absolute inset-0 w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#12367F]/85" />
                  <span className="absolute top-4 left-4 text-xs uppercase tracking-wider px-3 py-1 rounded-full bg-white/95 text-[#12367F] font-medium">
                    {w.category}
                  </span>
                  <div className="absolute bottom-4 left-4 right-4 text-white">
                    <p className="font-display uppercase text-3xl md:text-4xl leading-none mb-2">{w.title}</p>
                  </div>
                  <div className="absolute top-4 right-4 h-10 w-10 rounded-full bg-[#2EF5FF] text-[#12367F] grid place-items-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <ArrowUpRight className="h-5 w-5" />
                  </div>
                </div>
                <div className="pt-5">
                  <p className="text-[#12367F] font-semibold text-lg leading-snug">
                    {w.subtitle}
                  </p>
                  <p className="mt-3 text-[#12367F]/70 text-sm leading-relaxed line-clamp-3">
                    {w.description}
                  </p>
                  <div className="mt-5 grid grid-cols-3 gap-3 border-t border-[#12367F]/10 pt-5">
                    {w.metrics.map((m) => (
                      <div key={m.label}>
                        <p className="font-display text-2xl md:text-3xl text-[#12367F] leading-none">{m.value}</p>
                        <p className="text-[11px] uppercase tracking-wider text-[#12367F]/60 mt-1">{m.label}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <FooterCTA />
      <Footer />
    </main>
  );
};

export default Work;
